

// Пункты верхнего меню.
// external: true — ссылка на другой домен, роутер её не обслуживает (обычный <a>).
// shortName — укороченная подпись для мобильного меню.
export const menuRef = [
    {
        id: 1,
        path: '/',
        name: 'Для дома',


    },
    {
        id: 2,
        path: '/business',
        name: 'Бизнесу',
    },
    {
        id: 3,
        path: '/system',
        name: 'Системная интеграция',
        shortName: 'Интеграция',

    },
    {
        id: 5,
        path: 'https://domain.nets.tj',
        name: 'Домены',
        external: true,
        // isNew — пульсирующая точка-индикатор у пункта (стиль в Menu.scss)
        isNew: true,
    },
    {
        id: 6,
        path: '/vacancies',
        name: 'Вакансии',
    },

]

// К какому разделу верхнего уровня относится страница. Одна таблица на весь
// сайт: чтобы привязать новую страницу, достаточно одной строки.
// section — это path пункта из menuRef. Страницы, которых тут нет
// (/video, /whois, /news, /oferta, служебные), раздел не подсвечивают.
export const ROUTE_SECTION = [
    { match: '/', exact: true, section: '/' },
    { match: '/cash', section: '/' },
    { match: '/router', section: '/' },
    { match: '/business', section: '/business' },
    { match: '/hosting', section: '/business' },
    { match: '/system', section: '/system' },
    { match: '/directum', section: '/system' },
    { match: '/vacancies', section: '/vacancies' },
    { match: '/vacanciesItem', section: '/vacancies' },
]

// Возвращает path активного раздела или null. Сравнение по префиксу пути,
// чтобы /vacanciesItem/12 попадал в «Вакансии»; корень — только точным.
export const sectionForPath = (pathname = '/') => {
    const hit = ROUTE_SECTION.find(({ match, exact }) =>
        exact
            ? pathname === match
            : pathname === match || pathname.startsWith(match + '/')
    )
    return hit ? hit.section : null
}
